import { useReduxState } from 'hooks';
import { CSSProperties, ReactNode } from 'react';

const ModalContent = ({
  children,
  style
}: {
  children: ReactNode;
  style?: CSSProperties;
}) => {
  const { theme } = useReduxState();

  return (
    <div className="modal-content" style={style}>
      {children}

      <style jsx>{`
        .modal-content {
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          font-weight: 600;
          overflow: auto;
          padding: 15px;
        }
      `}</style>
    </div>
  );
};

export default ModalContent;
